/* ============================================================
   Fable Motion Layer v13 — The Twelver Studios
   Companion to fable-motion.css. Vanilla JS, no dependencies.
   v13: per-card scroll-reveal removed. Product cards are
   Flickity carousel cells; adding a reveal transform to them
   fought Flickity's own positioning transform. The whole
   carousel section still reveals as one unit (clean). Tiles and
   sections are unaffected. Homepage still strips the theme's
   duplicate AOS entrance system.
   ============================================================ */
(function () {
  'use strict';

  var docEl = document.documentElement;
  var reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  docEl.classList.add('fm-on');
  if (reduced) return;

  function onReady(fn) {
    if (document.readyState !== 'loading') { fn(); }
    else { document.addEventListener('DOMContentLoaded', fn); }
  }

  onReady(function () {
    var main = document.getElementById('MainContent');
    if (!main) return;
    var isIndex = document.body.className.indexOf('template-index') !== -1;
    var vh = window.innerHeight;

    /* ---- Homepage: strip the theme's AOS entrance system ----
       Removing data-aos removes the CSS that hides elements, so
       nothing waits on two stacked animation systems. */
    if (isIndex) {
      var aosEls = [].slice.call(main.querySelectorAll('[data-aos]'));
      aosEls.forEach(function (el) {
        el.removeAttribute('data-aos');
        el.removeAttribute('data-aos-delay');
        el.classList.remove('aos-init', 'aos-animate');
      });
    }

    /* ---- Hero caption scroll depth ---- */
    var hero = main.querySelector('.slideshow-section');
    if (hero && hero.getBoundingClientRect().top + window.pageYOffset < window.innerHeight) {
      hero.classList.add('fm-hero');
      var ticking = false;
      var update = function () {
        ticking = false;
        var y = window.pageYOffset;
        if (y > (hero.offsetHeight || 1)) return;
        hero.style.setProperty('--fm-shift', (y * -0.22).toFixed(1));
      };
      window.addEventListener('scroll', function () {
        if (!ticking) { ticking = true; window.requestAnimationFrame(update); }
      }, { passive: true });
      update();
    }

    /* ---- Section rises (all pages) + category tile stagger ----
       NOTE: product carousel cards are deliberately NOT revealed
       individually — they are Flickity cells and a transform on
       them conflicts with Flickity's positioning. The whole
       carousel section reveals as one block instead. */
    var sections = [].slice.call(main.children).filter(function (el) {
      return el.className.indexOf('shopify-section') !== -1;
    });
    sections.forEach(function (s, i) {
      if (i === 0) return; /* never the topmost section */
      if (s.getBoundingClientRect().top < vh * 0.85) return; /* visible on load — no pop */
      s.setAttribute('data-fm-reveal', '');
    });
    var tiles = [].slice.call(main.querySelectorAll('.gallery__section-block'));
    tiles.forEach(function (t, i) {
      if (t.getBoundingClientRect().top < vh * 0.9) return;
      t.setAttribute('data-fm-reveal', '');
      t.style.setProperty('--fm-delay', ((i % 4) * 0.08).toFixed(2) + 's');
    });
    var revealEls = [].slice.call(main.querySelectorAll('[data-fm-reveal]'));
    if (revealEls.length) {
      if ('IntersectionObserver' in window) {
        var revIO = new IntersectionObserver(function (entries) {
          entries.forEach(function (e) {
            if (e.isIntersecting) { e.target.classList.add('fm-in'); revIO.unobserve(e.target); }
          });
        }, { rootMargin: '0px 0px -8% 0px', threshold: 0.05 });
        revealEls.forEach(function (el) { revIO.observe(el); });
      } else {
        revealEls.forEach(function (el) { el.classList.add('fm-in'); });
      }
    }
  });
})();
